




export default Object.assign({},
  {
  }
);
